// extracted by mini-css-extract-plugin
export default {"datalist":"SelectFromCloudContent__datalist--2pTRT","button":"SelectFromCloudContent__button--2g_Wz","buttonGroup":"SelectFromCloudContent__buttonGroup--2D-1I"};